import React from 'react';
import { Link } from 'react-router-dom';
import underLine from '../assets/home/underLine.png';
import { servicesData } from '../common/servicesData';
import ServiceCard from './ServiceCard';
const ServiceSection = () => {
  return (
    <div
      className='bg-[#E1F0FF]'
      id='services'
    >
      <div className='containers py-10'>
        <div className='flex justify-center items-center'>
          <div className='text-center'>
            <h4 className='customHeadingTwo'>
              Our Trusted Excellence in Global Business
            </h4>
            <h1 className='customHeading '>
              We Provide Wide Range of Business Services
            </h1>
            <div className='flex justify-center items-center py-5'>
              <img
                src={underLine}
                alt='under-line'
              />
            </div>
          </div>
        </div>
        <div className='grid lg:grid-cols-3 gap-10 pt-10'>
          {servicesData?.slice(0, 6)?.map((item, index) => (
            <ServiceCard
              key={index}
              image={item?.img}
              link={item?.link}
              title={item?.title}
              subTitle={item?.sutTitle}
            />
          ))}
        </div>
        <div className='flex justify-center '>
          <Link to='/all-services'>
            {' '}
            <button className='customBtn my-5 px-10'>View All</button>{' '}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
